module.exports = __webpack_public_path__ + "static/media/durationDark.3c0e7746.svg";